<div class="onboarding-form onboarding-form-wider">
  <h1>User Agreements</h1>
  <p class="text-muted fw-semibold mb-4">We have updated our user agreements.</p>
  <div class="h4 mb-4">
    Please accept our latest
    <a
      class="text-secondary text-decoration-none"
      target="_blank"
      rel="noopener"
      routerLink="/terms-and-conditions">
      Terms of Use
    </a>
    ,
    <a
      class="text-secondary text-decoration-none"
      target="_blank"
      rel="noopener"
      routerLink="/prepaid-card-terms-and-conditions">
      Prepaid Card Terms and Conditions
    </a>
    and
    <a
      class="text-secondary text-decoration-none"
      target="_blank"
      rel="noopener"
      routerLink="/privacy-policy">
      Privacy Policy
    </a>
    in order to continue using Paystashio.
  </div>

  <div class="row">
    <div class="col-auto">
      <button
        id="cancelBtn"
        class="btn btn-outline-dark btn-lg"
        type="submit"
        (click)="onLogout()">
        Log out
      </button>
    </div>
    <div class="col-auto">
      <button
        id="acceptBtn"
        class="btn btn-primary btn-lg"
        type="submit"
        (click)="onAccept()">
        Accept all
        <i class="iconoir-arrow-right ms-2"></i>
      </button>
    </div>
  </div>
</div>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
